import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Quote, ArrowUpRight } from 'lucide-react';
const messages = [{
  role: 'Principal',
  name: 'Brig Gen S. M. Mahbub-Ul-Alam',
  image: 'https://cdn.magicpatterns.com/uploads/6iSFi4XYxWDzpBArWv1w47/principal.png',
  shortMessage: 'Education is not just about acquiring knowledge; it is about building character and nurturing values. At MDIC, we strive to create an environment where every student can discover their potential.',
  fullMessage: 'Education is not just about acquiring knowledge; it is about building character and nurturing values. At MDIC, we strive to create an environment where every student can discover their potential and grow into responsible, compassionate individuals. Our dedicated faculty and modern facilities ensure that each student receives the best possible education rooted in faith and excellence. We are committed to preparing our students not just academically, but as well-rounded human beings ready to contribute positively to society.'
}, {
  role: 'Chairman',
  name: 'Shah Abdul Hannan',
  image: 'https://cdn.magicpatterns.com/uploads/9NXp5mKmWPEAKVYpA31QWY/chairman.png',
  shortMessage: 'Our vision is to establish MDIC as a center of excellence that combines modern education with Islamic values. We are committed to providing world-class facilities and opportunities.',
  fullMessage: 'Our vision is to establish MDIC as a center of excellence that combines modern education with Islamic values. We are committed to providing world-class facilities and opportunities that prepare our students for success in this life and the hereafter. Since our founding, we have remained steadfast in our mission to deliver quality education that is both academically rigorous and morally grounded. We believe that true education shapes not only the intellect but also the soul, and MDIC stands as a testament to that belief.'
}];
export function MessageSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const toggleExpand = (role: string) => {
    setExpanded(prev => ({
      ...prev,
      [role]: !prev[role]
    }));
  };
  return <section className="py-20 bg-light-gray" data-id="element-176">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="text-center mb-12" data-id="element-178">
          <h2 className="text-4xl font-heading font-bold text-text-dark mb-2" data-id="element-179">
            Messages
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-180"></div>
        </div>
        <div ref={ref} className="grid md:grid-cols-2 gap-8" data-id="element-181">
          {messages.map((msg, index) => {
          const isExpanded = expanded[msg.role];
          return <motion.div key={msg.role} initial={{
            opacity: 0,
            y: 30
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow p-8 relative flex flex-col" data-id="element-182">
                <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-183" />

                <div className="flex items-center mb-6" data-id="element-184">
                  <img src={msg.image} alt={msg.name} className="w-20 h-20 rounded-full object-cover object-top border-4 border-gold flex-shrink-0" data-id="element-185" />
                  <div className="ml-4" data-id="element-186">
                    <h3 className="text-lg font-heading font-semibold text-text-dark leading-tight" data-id="element-187">
                      {msg.name}
                    </h3>
                    <p className="text-gold font-medium mt-1" data-id="element-188">{msg.role}</p>
                  </div>
                </div>

                <p className="text-text-muted leading-relaxed italic flex-1" data-id="element-189">
                  "{isExpanded ? msg.fullMessage : msg.shortMessage}"
                </p>

                <button onClick={() => toggleExpand(msg.role)} className="inline-flex items-center gap-1 text-primary font-semibold border-b-2 border-primary pb-0.5 hover:text-primary-dark hover:border-primary-dark transition-colors mt-4 self-start" data-id="element-190">
                  {isExpanded ? 'Read less' : 'Read more'}
                  <ArrowUpRight size={16} className={`transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-191" />
                </button>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}